import { Link } from '@mui/material';
import { Fragment } from 'react';
import { findLegalRefMatches } from './legal-references';

/**
 * Renders plain text with every legal citation the catalog knows
 * (Reg. CE 852/2004, D.Lgs. 18/2023, ...) turned into an external link to its
 * official source. Text without citations renders unchanged.
 */
export function LinkifiedLegalText({ text }: { text: string }) {
  const matches = findLegalRefMatches(text);
  if (matches.length === 0) {
    return <>{text}</>;
  }
  const parts: React.ReactNode[] = [];
  let cursor = 0;
  for (const match of matches) {
    if (match.start > cursor) {
      parts.push(<Fragment key={cursor}>{text.slice(cursor, match.start)}</Fragment>);
    }
    parts.push(
      <Link
        key={`${match.entry.id}-${match.start}`}
        href={match.entry.url}
        target="_blank"
        rel="noopener noreferrer"
      >
        {text.slice(match.start, match.end)}
      </Link>,
    );
    cursor = match.end;
  }
  if (cursor < text.length) {
    parts.push(<Fragment key={cursor}>{text.slice(cursor)}</Fragment>);
  }
  return <>{parts}</>;
}
